import { inject, Injectable } from '@angular/core';
import {
  Action,
  createSelector,
  NgxsOnInit,
  State,
  StateContext,
} from '@ngxs/store';
import { UISettings } from 'src/app/models/ui-settings';
import {
  EnvironmentService,
  ScreenSize,
} from 'src/app/services/environment/environment.service';
import { UpdateUISettingAction } from './ui-settings.actions';

export type UISettingsStateModel = UISettings;

@State<UISettingsStateModel>({
  name: 'uisettings',
  defaults: {
    incidentDashboardSettings: {
      widgets: [],
      cardVariant: 'glass',
      editable: false,
    },
  },
})
@Injectable()
export class UISettingsState implements NgxsOnInit {
  environmentService = inject(EnvironmentService);

  static setting<T extends keyof UISettingsStateModel>(settingName: T) {
    return createSelector([UISettingsState], (state: UISettingsStateModel) => {
      return state[settingName] as UISettingsStateModel[T];
    });
  }

  @Action(UpdateUISettingAction)
  updateUISetting(
    ctx: StateContext<UISettingsStateModel>,
    { setting, value }: UpdateUISettingAction<keyof UISettingsStateModel>
  ) {
    if (value === undefined) {
      return;
    }

    if (
      typeof value === 'object' &&
      typeof ctx.getState()[setting] === 'object'
    ) {
      ctx.patchState({
        [setting]: {
          ...(ctx.getState()[setting] as object),
          ...(value as object),
        },
      });
    } else {
      ctx.patchState({
        [setting]: value,
      });
    }
  }

  ngxsOnInit(ctx: StateContext<UISettingsStateModel>) {
    this.environmentService.settings$.subscribe(settings => {
      if (!ctx.getState().isSidemenuPinned) {
        const isCollapsed = settings.screenSize <= ScreenSize.SmallDesktop;

        ctx.patchState({
          isSidemenuCollapsed: isCollapsed,
        });
      }
    });
    if (!ctx.getState().incidentDashboardSettings) {
      ctx.patchState({
        incidentDashboardSettings: {
          widgets: [],
          cardVariant: 'glass',
          editable: false,
        },
      });
    }
  }
}
